export default defineNuxtPlugin(() => {
  const disclaimer = reactive({
    isDisclaimerOpen: false as boolean,
    shareDisclaimer: false as boolean,
    redirectDisclaimer: false as boolean,
    toggleShareDisclaimer(e: { shared: boolean }): void {      
      this.shareDisclaimer = e['shared']
        ? Boolean(e.shared)
        : (this.shareDisclaimer as boolean);
      this.isDisclaimerOpen = e['shared']
        ? Boolean(e.shared)
        : (this.shareDisclaimer as boolean);
    },
    toggleRedirectDisclaimer(e: { externalSource: boolean }): void {
      this.redirectDisclaimer = e['externalSource']
        ? Boolean(e.externalSource)
        : (this.redirectDisclaimer as boolean);
      this.isDisclaimerOpen = e['externalSource']
        ? Boolean(e.externalSource)
        : (this.redirectDisclaimer as boolean);
    },
  });
  return {
    provide: { disclaimer },
  };
});
